import { render } from "./CreateVideo.vue?vue&type=template&id=4183e59c&scoped=true"
import script from "./CreateVideo.vue?vue&type=script&lang=js"
export * from "./CreateVideo.vue?vue&type=script&lang=js"

import "./CreateVideo.vue?vue&type=style&index=0&id=4183e59c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4183e59c"]])

export default __exports__